import { EFinancingCompany } from '@if/core/types'
import { Tab, Tabs } from '@mui/material'
import Breadcrumb from '@src/components/Breadcrumb'
import ReportsList from '@src/components/reportsList'
import TabPanel from '@src/components/TabPanel'
import { useGetMerchantReports, useMerchantById, useMerchantUserList } from '@src/data/api/merchants-api/merchants-api'
import { EMerchantReportFrequency } from '@src/data/types/Constants'
import { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import MerchantInfoTab from '../../components/MerchantInfoTab'
import Users from '../../components/userList'
import MerchantInformation from './merchantInformation'

const MerchantPage = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const [users, isFetchingUsers] = useMerchantUserList(id ?? '')
  const [shouldPoll, setShouldPoll] = useState(false)
  const [reportsSummary, isFetchingReports] = useGetMerchantReports(id ?? '', shouldPoll)
  const [merchant] = useMerchantById(id ?? '')
  const [selectedTabId, setSelectedTabId] = useState(0)

  const handleTabChange = (_event: ChangeEvent<object>, newValue: number) => {
    setSelectedTabId(newValue)
  }

  const handleGenerateNewReport = () => {
    setShouldPoll(true)
  }

  useEffect(() => {
    if (reportsSummary && reportsSummary.length > 0 && shouldPoll === true) {
      const latestReport = reportsSummary[0]
      const reportDate = new Date(latestReport.createdOn)

      // Check if the latest report is recent within the 10 seconds
      if (Date.now() - reportDate.getTime() < 10 * 1000) {
        setShouldPoll(false)
      }
    }
  }, [shouldPoll, reportsSummary])

  const breadCrumbs = [
    { path: '/', label: t('breadcrumbs.home') },
    {
      path: `/merchant/${id}/view`,
      label: t('breadcrumbs.merchant').concat(` : ${merchant?.name}`),
    },
  ]

  return (
    <>
      <div style={{ marginLeft: '15px' }}>
        <Breadcrumb trees={breadCrumbs} />
      </div>
      <MerchantInformation merchant={merchant!} />
      <div style={{ display: 'flex', justifyContent: 'left', marginLeft: '30px' }}>
        <Tabs value={selectedTabId} onChange={handleTabChange}>
          <Tab label={t('common.details')} />
          <Tab label={t('common.users')} />
          {merchant?.financingCompanyId === EFinancingCompany.IFinance && <Tab label={t('common.reports')} />}
        </Tabs>
      </div>
      <TabPanel value={selectedTabId} index={0}>
        {merchant && <MerchantInfoTab merchant={merchant} />}
      </TabPanel>
      <TabPanel value={selectedTabId} index={1}>
        <Users merchantId={id!} usersList={users} isPendingSearchUsers={isFetchingUsers} />
      </TabPanel>
      {merchant?.financingCompanyId === EFinancingCompany.IFinance && (
        <TabPanel value={selectedTabId} index={2}>
          <ReportsList
            merchantId={id!}
            reportsSummary={reportsSummary}
            isFetchingReports={isFetchingReports || shouldPoll}
            onGenerateReport={handleGenerateNewReport}
            generateReportDisabled={
              !merchant?.reportGenerationFrequency ||
              merchant.reportGenerationFrequency === EMerchantReportFrequency.never
            }
          />
        </TabPanel>
      )}
    </>
  )
}

export default MerchantPage
